import { TenantEntity } from '../TenantEntity'

export class AirTransitRoutingDescription extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AirTransitRoutingDescription'
  }
  get firstTransshipmentPortCode() {
    return this._data.firstTransshipmentPortCode
  }
  set firstTransshipmentPortCode(firstTransshipmentPortCode) {
    this._data.firstTransshipmentPortCode = firstTransshipmentPortCode
  }
  get secondTransshipmentPortCode() {
    return this._data.secondTransshipmentPortCode
  }
  set secondTransshipmentPortCode(secondTransshipmentPortCode) {
    this._data.secondTransshipmentPortCode = secondTransshipmentPortCode
  }
  get beginValidDate() {
    return this._data.beginValidDate
  }
  set beginValidDate(beginValidDate) {
    this._data.beginValidDate = beginValidDate
  }
  get endValidDate() {
    return this._data.endValidDate
  }
  set endValidDate(endValidDate) {
    this._data.endValidDate = endValidDate
  }
  get createDepartment() {
    return this._data.createDepartment
  }
  set createDepartment(createDepartment) {
    this._data.createDepartment = createDepartment || 0
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get flightDescriptionUuid() {
    return this._data.flightDescriptionUuid
  }
  set flightDescriptionUuid(flightDescriptionUuid) {
    this._data.flightDescriptionUuid = flightDescriptionUuid
  }
}
